export default "__VITE_ASSET__MnbFIQ0f__"